import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { getJSON } from './api';
import { PeriodToggle } from './PeriodToggle';
import { StatsTable, Totals } from './StatsTable';
import { RoundsList } from './RoundsList';

// "Who played this game": players for one game, click a player for their rounds.
export const GamePlayersDialog = ({ gameId, onClose }) => {
    const [period, setPeriod] = useState('today');
    const [data, setData] = useState(null);
    const [player, setPlayer] = useState(null);
    useEffect(() => {
        if (!gameId) return;
        setData(null);
        getJSON(`/admin/games/${gameId}/players?period=${period}`).then(setData).catch(() => setData({ players: [], totals: {} }));
    }, [gameId, period]);
    useEffect(() => { setPlayer(null); }, [gameId]);
    return (
        <Dialog open={!!gameId} onOpenChange={(o) => !o && onClose()}>
            <DialogContent className="max-w-4xl bg-zinc-900 border-zinc-800 text-white" data-testid="game-players-dialog">
                <DialogHeader>
                    <DialogTitle className="flex flex-wrap items-center gap-3">
                        {player ? <button type="button" className="text-xs text-zinc-400 hover:text-white" onClick={() => setPlayer(null)} data-testid="game-players-back">← All players</button> : null}
                        <span data-testid="game-players-title">{data?.game_name || 'Game'}{player ? ` · ${player.user_name}` : ' · who played'}</span>
                        <span className="ml-auto"><PeriodToggle value={period} onChange={setPeriod} testid="game-players-period" /></span>
                    </DialogTitle>
                </DialogHeader>
                {!data ? <p className="text-xs text-zinc-500 py-6 text-center">Loading…</p> : player ? (
                    <RoundsList userId={player.user_id} gameId={gameId} period={period} />
                ) : data.players.length === 0 ? (
                    <p className="text-xs text-zinc-500 py-6 text-center" data-testid="game-players-empty">Nobody played this game in this period.</p>
                ) : (
                    <div className="space-y-3">
                        <Totals t={data.totals} />
                        <StatsTable rows={data.players} labelKey="user_name" labelTitle={`Players (${data.players.length})`} onPick={setPlayer} testid="game-players-table" />
                        <p className="text-[11px] text-zinc-500">House = bets minus wins (green = the house is up). Click a player to see every round.</p>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};
